exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Getting-started-page{text-align:center;color:#fff}.Getting-started-page>div{max-width:650px;text-align:left}.Getting-started-page h1{font-size:48px;text-align:center}.Getting-started-page h2{font-size:1.5rem;font-weight:700}.Getting-started-page h3{font-size:1rem;font-weight:700}.Getting-started-page .notice{border-left:5px solid #d8d8d8;padding-left:10px;font-size:13px;margin-top:30px}.Getting-started-page .agents-list li{margin-bottom:1em}.Getting-started-page ol{margin:0;counter-reset:getting-started-counter}.Getting-started-page li{position:relative;margin-bottom:70px}.Getting-started-page li:before{content:counter(getting-started-counter) \".\";counter-increment:getting-started-counter;position:absolute;top:15px;left:-100px;font-size:72px;font-weight:100;color:#cdcdcd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/home/GettingStartedPage/index.scss
// module id = 1029
// module chunks = 0